import { useLastPathSegment } from 'shared/hooks'
import { useCallingStepsContext } from 'pages/settings/pages/compliance/pages/calling/context/callingStepsContext'
import { type CallingRoutesSteps } from 'pages/settings/pages/compliance/pages/calling/route/type'

export const useLayoutTitle = () => {
  const { getLayoutTitle } = useCallingStepsContext()

  return getLayoutTitle(useLastPathSegment() as CallingRoutesSteps)
}
